import {
  Card,
  Title2,
  Body2,
  CardHeader,
  CardFooter,
  Button,
} from "@fluentui/react-components";

export const TeamInstallationFailure = ({
  redirect: { url, openInNewTab },
}: {
  redirect: {
    url: string;
    openInNewTab: boolean;
  };
}) => (
  <Card className="w-full max-w-lg border-0 shadow-lg">
    <CardHeader header={<Title2>Team not found</Title2>} />
    <Body2>
      We could not load the team data required for this feature. Please try
      again or report this issue to the BeZoned team.
    </Body2>
    <CardFooter className="flex justify-end gap-2">
      <Button
        appearance="primary"
        as="a"
        href={url}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        target={openInNewTab ? "_blank" : undefined}
      >
        Go to Lobby
      </Button>
    </CardFooter>
  </Card>
);
